/**
 * 获取图片的完整URL
 * @param {string} url - 图片URL（可能是相对路径、绝对路径或纯文件名）
 * @returns {string} 完整的图片URL
 */
export function getImageFullUrl(url) {
    if (!url) return ''

    // 已经是绝对URL（http/https/data:），直接返回
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
        return url
    }

    // 已经是完整路径（以 /api/uploads/ 开头）
    if (url.startsWith('/api/uploads/')) {
        return url
    }

    // 获取后端基础地址
    const apiBase = process.env.VUE_APP_API_BASE || ''

    // 如果是纯文件名（如 5064179e-e33e-4c45-8b1b-f544c7b0ac80.jpg），补全路径
    if (!url.startsWith('/')) {
        const uploadPath = '/api/uploads/' + url
        if (apiBase) {
            return apiBase.replace(/\/+$/, '') + uploadPath
        }
        return uploadPath
    }

    // 其他以 / 开头的路径
    if (apiBase) {
        return apiBase.replace(/\/+$/, '') + url
    }

    // 没有配置后端地址，使用相对路径（适合Nginx反向代理场景）
    return url
}